import React from 'react';
import styles from './styles.module.scss';
import { ProductType } from '../../types';
import { generateSavingsSummary, SavingsSummaryItem } from '../../config/savingsConfig';
import { formatCurrency } from '../../utils/helpers';

interface SavingsSummaryProps {
  productType: ProductType;
  zipFlag: boolean | null;
  zipCode?: string;
}

/**
 * Restituisce la data di scadenza formattata per un bonus
 * Usa la scadenza dal database se disponibile, altrimenti fallback per PNRR
 */
function formatExpiryDate(item: SavingsSummaryItem): string {
  // Se l'item ha una scadenza dal database, usala
  if (item.scadenza) {
    // Converti formato da "31.12.2025" a "31/12/25"
    const parts = item.scadenza.split('.');
    if (parts.length === 3) {
      return `${parts[0]}/${parts[1]}/${parts[2]}`;
    }
    return item.scadenza;
  }
  
  // Fallback: PNRR CER Enpal ha scadenza
  if (item.label === 'PNRR CER Enpal') {
    return '22/11/2026';
  }
  
  return '-';
}

/**
 * Riepilogo dei risparmi nella slide di successo
 * 
 * NUOVA VERSIONE: Usa i dati dal database CAP per mostrare
 * tutti i bonus disponibili per il comune selezionato,
 * inclusi bonus regionali e provinciali.
 */
const SavingsSummary: React.FC<SavingsSummaryProps> = ({
  productType,
  zipFlag,
  zipCode,
}) => {
  const summary = generateSavingsSummary(productType, zipFlag, zipCode);

  // Raggruppa bonus per categoria solo per combo
  const isCombo = productType === 'Photovoltaic + Heatpump';
  const pvItems = isCombo ? summary.items.filter((item: any) => item.category === 'PV') : [];
  const hpItems = isCombo ? summary.items.filter((item: any) => item.category === 'HP') : [];
  const uncategorizedItems = isCombo ? summary.items.filter((item: any) => !item.category) : summary.items;

  return (
    <div className={styles.savingsSummaryBox}>
      <p className={styles.summaryTitle}>
        Risparmio in 10 anni:
      </p>

      {/* Header della tabella */}
      <div className={styles.savingsHeader}>
        <span className={styles.headerLabel}>VANTAGGIO</span>
        <span className={styles.headerValue}>IMPORTO</span>
        <span className={styles.headerExpiry}>SCADENZA</span>
      </div>

      {summary.items.map((item, index) => (
        <div key={index} className={styles.savingsItem}>
          <span className={styles.itemLabel}>{item.label}</span>
          <span className={styles.itemValue}>{item.value}</span>
          <span className={styles.itemExpiry}>{formatExpiryDate(item)}</span>
        </div>
      ))}

      <div className={styles.savingsSeparator} />

      <div className={styles.savingsTotal}>
        <span className={styles.itemLabel}>Risparmio Totale</span>
        <span className={styles.itemValue}>{formatCurrency(summary.total)}</span>
        <span className={styles.itemExpiry}></span>
      </div>

      <div className={styles.savingsItem}>
        <span className={styles.itemLabel}>Guadagni Trading Energia</span>
        <span className={`${styles.itemValue} ${summary.co2Saved === 'Scoprilo in chiamata' ? styles.redCallText : ''}`}>
          {summary.co2Saved}
        </span>
        <span className={styles.itemExpiry}></span>
      </div>
    </div>
  );
};

export default SavingsSummary;
